import React, { useState, useEffect, useRef } from "react";
import './MenuNavbar.css';
import { FiChevronDown } from "react-icons/fi";
import { NavLink } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";

const MenuNavbar = () => {
  const { instance } = useMsal();

  // State to manage visibility of submenus
  const [isMenuSubMenuHovered, setMenuSubMenuHovered] = useState(false);
  const [isMenuSubMenuClicked, setMenuSubMenuClicked] = useState(false);
  const [showLearningSubMenuHovered, setShowLearningSubMenuHovered] = useState(false);
  const [showLearningSubMenuClicked, setShowLearningSubMenuClicked] = useState(false);

  // Refs to capture submenu elements
  const submenuRef = useRef(null);
  const learningSubmenuRef = useRef(null);

  // Event handlers for submenu toggling
  const handleMouseEnter = () => {
    setMenuSubMenuHovered(true);
  };

  const handleMouseLeave = () => {
    setMenuSubMenuHovered(false);
  };

  const toggleEntryLevelSubMenu = () => {
    setMenuSubMenuClicked(!isMenuSubMenuClicked);
  };

  const toggleLearningSubMenu = () => {
    setShowLearningSubMenuClicked(!showLearningSubMenuClicked);
  };



  // const [showUser, setShowUser] = useState(false);
  // const [isReport, setIsReport] = useState(false);

  //   const usersList = [
  //     "jeevadharani.ramanan@accenture.com",
  //     "reshmi.haridas.m@accenture.com",
  //     "reshmi.haridas.m@ds.dev.accenture.com",
  //     "meena.deepak@accenture.com",
  //     "h.srinivasan@accenture.com",
  //     "vineet.sachdev@accenture.com",
  //     "supriya.poomagame@accenture.com",
  //     "m.snehalatha@accenture.com",
  //     "shantanu.k.mishra@accenture.com",
  //     "karthik.attavar@accenture.com",
  //     "n.hari.narayanan@accenture.com",
  //     "aravind.kandi@accenture.com",
  //     "v.bheemarao.dani@accenture.com",
  //     "amrutha.a.ravindra@accenture.com",
  //     "sriparna.a.das@accenture.com",

  //   ];
  //   const reportUsers=[
  //     "meena.deepak@accenture.com",
  //     "reshmi.haridas.m@ds.dev.accenture.com",
  //     "reshmi.haridas.m@accenture.com",
  //     "h.srinivasan@accenture.com",
  //     "vineet.sachdev@accenture.com",
  //     "jeevadharani.ramanan@accenture.com",
  // "kicha.ramamurthy@accenture.com",
  // "anupama.nithyanand@accenture.com",
  // "vivek.lal.agrawal@accenture.com",
  // "gajendra.mallik@accenture.com",
  // "v.bheemarao.dani@accenture.com"


  //   ]
  //   const activeAccount = instance.getActiveAccount();
  //   const adminShow = false;
  //   useEffect(() => {
  //     if (activeAccount) {
  //       const val = usersList.some((item) => item === activeAccount.username)
  //         ? setShowUser(true)
  //         : setShowUser(false);


  //     } else {
  //       console.log("Something Wrong...!");
  //     }

  //     if (activeAccount) {
  //       const val1 = reportUsers.some((item) => item === activeAccount.username)
  //         ? setIsReport(true)
  //         : setIsReport(false);


  //     } else {
  //       console.log("Something Wrong...!");
  //     }
  //   }, []);
  return (
    <>
      <div className="nav-menu-bar">
        <div className="navContainer">
          <ul className="navMenu">
            <li>
              <NavLink exact to="/homeContent" activeClassName="active-menu-item">
                Home
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/entryLevelLearning" activeClassName="active-menu-item">
                Entry Level Learning
              </NavLink>
            </li>
            <li onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={toggleEntryLevelSubMenu}>
              {/* Example of a menu item with a submenu */}
              <NavLink exact to="/SecuritySpecializationAcademyNew" activeClassName="active-menu-item">
                Security Learning Framework
                <span className="submenu-arrow">
                  <FiChevronDown />
                </span>
              </NavLink>
              {(isMenuSubMenuHovered || isMenuSubMenuClicked) && (
                <ul className="submenu" ref={submenuRef}>
                  <li className="submenu-item">
                    <NavLink exact to="/SecuritySpecializationAcademyNew" activeClassName="active-menu-item">
                      {/* Security Specialization Academy */}
                      Specialization
                    </NavLink>
                  </li>
                  <li className="submenu-item">
                    <NavLink exact to="/delivery" activeClassName="active-menu-item">
                      {/* Delivery Learning Academy */}
                      Delivery
                    </NavLink>
                  </li>
                  <li className="submenu-item">
                    <a href="https://atci.lkm-securitylearnings.accenture.com/IndustryLearningAcademy/" target="_blank" activeClassName="active-menu-item">
                      {/* Industry Learning Academy */}
                      Industry
                    </a>
                  </li>
                  <li className="submenu-item">
                    <NavLink exact to="/professional" activeClassName="active-menu-item">
                      {/* Professional Development Academy */}
                      Professional
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>
            {/* <li>
              <NavLink exact to="/delivery" activeClassName="active-menu-item">
                Delivery
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/specializations" activeClassName="active-menu-item">
                Specializations
              </NavLink>
            </li> */}
            {/* <li>
              <NavLink exact to="/industry" activeClassName="active-menu-item">
                Industry
              </NavLink>
            </li> */}
            {/* <li>
              <a href="https://atci.lkm-securitylearnings.accenture.com/IndustryLearningAcademy/" target="_blank">Industry</a>
            </li>
            <li>
              <NavLink exact to="/professional" activeClassName="active-menu-item">Professional</NavLink>
            </li> */}
            {/* <li>
              <NavLink exact to="/securityLearningFramework" activeClassName="active-menu-item">
                Security Learning Framework
              </NavLink>
            </li> */}
            <li>
              <NavLink exact to="/CrossOffering" activeClassName="active-menu-item">
                Cross Offering
              </NavLink>
            </li>
            <li>
              <a href="https://ts.accenture.com/sites/SecurityLearningGuidanceWizard/SecurityAcademy/SiteAssets/index.aspx#Ecosystem" exact to="" activeClassName="active-menu-item" target="_blank">
                Eco System Partners
              </a>
            </li>
            <li>
              <NavLink exact to="/keyInitiatives" activeClassName="active-menu-item">
                Key Initiatives
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/Calendar" activeClassName="active-menu-item">
                Calendar
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/learningHighlights" activeClassName="active-menu-item">
                Learning Highlights
              </NavLink>
            </li>
            {/* <li>
              <a href="https://atci.lkm-securitylearnings.accenture.com/SecurityFoundationAcademy/" target="_blank">SFA</a>
            </li>
            <li>
              <a href="https://atci.lkm-securitylearnings.accenture.com/DeliveryAdeptAcademy/" target="_blank">DAA</a>
            </li> */}
            {/* <li>
                <a href="https://atci.lkm.delivery.accenture.com/TechCore/home" target="_blank">Tech Core</a>
            </li> */}
            {/* <li>
              <NavLink exact to="/FAQ" activeClassName="active-menu-item">
                FAQ
              </NavLink>
            </li> */}
            {/* <li>
              {showUser && <NavLink exact to="/Admin" activeClassName="active-menu-item">
                Administration
              </NavLink>}
            </li>
            <li>
              {showUser && <NavLink exact to="/Dashboard" activeClassName="active-menu-item">
                Dashboard
              </NavLink>}
            </li>
            <li>
              {isReport && <NavLink exact to="/Report" activeClassName="active-menu-item">
                Report
              </NavLink>}
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
};

export default MenuNavbar;
